import ParagraphText from '../ParagraphText';
import type { FunctionComponent } from 'react';

import { TEST_ID } from './constants';
import type { Props } from './types';

import styles from './styles.module.scss';

const TableHeaderText: FunctionComponent<Props> = ({ className = '', testId = TEST_ID, text }) => (
    <ParagraphText
        className={`${className} ${styles.tableHeaderText}`}
        testId={testId}
        text={text}
    />
);

export default TableHeaderText;
